export var ObjectToObjectType;
(function (ObjectToObjectType) {
    ObjectToObjectType[ObjectToObjectType["PART_TO_PART"] = 1] = "PART_TO_PART";
    ObjectToObjectType[ObjectToObjectType["PRODUCT_TO_PRODUCT"] = 2] = "PRODUCT_TO_PRODUCT";
})(ObjectToObjectType || (ObjectToObjectType = {}));
//# sourceMappingURL=object-to-object-type.js.map